import React, { useEffect, useState } from 'react';
import ReactQuill from 'react-quill-new';
import 'react-quill-new/dist/quill.snow.css';
import { DialogTitle } from '@mui/material';
import { Spinner } from 'reactstrap';
import toast from 'react-hot-toast';
import Api from 'services/api';
import {SubmitButton} from 'components/common/buttons/SubmitButton';

const UpdateEmailConfirmationModal = ({
  show,
  handleClose,
  appointmentId,
  standardHtml,
  onComplete,
  modalTitle = 'Send Appointment Update Email',
  modalMessage = 'The appointment update has been saved. Choose whether to send the standard client update email, compose a custom client email, or skip client notification.',
  sendEmailApi = Api.sendUpdateEmail,
}) => {
  const [loading, setLoading] = useState(false);
  const [customMode, setCustomMode] = useState(false);
  const [editorContent, setEditorContent] = useState(standardHtml || '');

  useEffect(() => {
    setEditorContent(standardHtml || '');
  }, [standardHtml]);

  const sendUpdateEmail = async (type) => {
    if (!appointmentId) {
      toast.error('Unable to send update email: missing appointment ID.');
      return;
    }

    if (type === 'custom' && !editorContent) {
      toast.error('Please enter a custom email body before sending.');
      return;
    }

    setLoading(true);
    try {
      const payload = { type };
      if (type === 'custom') {
        // payload.body = editorContent;
        payload.body = editorContent
        .replace(/&nbsp;/g, ' ')
        .replace(/\u00A0/g, ' ');
      }

      const response = await sendEmailApi(appointmentId, payload);
      if (response?.status >= 200 && response?.status < 300) {
        toast.success(response?.data?.message || 'Update email process completed.',{
          className: "successToast",
        });
        onComplete && onComplete(type);
      } else {
        toast.error(response?.data?.message || 'Failed to send update email.');
      }
    } catch (error) {
      toast.error(error?.response?.data?.message || 'Failed to send update email.');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
  if (show) {
    setCustomMode(false);
    setEditorContent(standardHtml || '');
  }
}, [show, standardHtml]);

  return (
    <>
    <div className={`modal fade show ${show ? 'd-block' : ''}`} tabIndex="-1" aria-hidden={!show} role="dialog">
      <div className="modal-dialog modal-dialog-centered modal-lg">
        <div className="modal-content full_modal">
          <DialogTitle style={{ padding: '0px' }}>
            <div className="modal-header header_modal align-items-center">
              <div></div>
              <h5 className="modal-title_u">{modalTitle}</h5>
              <button type="button" className="btn-close invisible" onClick={() => sendUpdateEmail('none')} disabled={loading}>
              </button>
            </div>
          </DialogTitle>

          <div className="modal-body modal_form_body">
            <div className="row-primary">
              <h2 style={{marginTop: 0, fontSize: '14px', lineHeight: '1.2' }}>
                {modalMessage}
              </h2>
            </div>

            {!customMode && (
              <div className="form-group mb-3">
                <div className="row-primary mb-2">
                <h2 style={{fontSize: '16px', fontWeight: 600}}>Standard Email Body</h2>
                </div>
                <div className="email-preview" style={{ border: '1px solid #e0e0e0', borderRadius: 10, padding: '12px 15px', minHeight: 180, background: '#fff' }}>
                  <div dangerouslySetInnerHTML={{ __html: standardHtml || '<p>No email preview available.</p>' }} />
                </div>
              </div>
            )}

            {customMode && (
              <div className="form-group mb-3">
                <div className="row-primary mb-2">
                <h2 style={{fontSize: '16px', fontWeight: 600}}>Custom Email Body</h2>
                </div>
                <ReactQuill
                  theme="snow"
                  value={editorContent}
                  onChange={setEditorContent}
                  modules={{ toolbar: [ [{ 'header': [1, 2, 3, false] }], ['bold', 'italic', 'underline'], [{ list: 'ordered' }, { list: 'bullet' }], ['link']] }}
                />
              </div>
            )}
          </div>

          <div className="modal-footer" style={{ justifyContent: 'space-between' }}>
            <div className="d-flex gap-2">
              {/* {!customMode ? (
                <SubmitButton
                  type="button"
                  className="main_button"
                  onClick={() => sendUpdateEmail('standard')}
                  disabled={loading}
                  btnText={loading ? "Sending..." : "Send Standard Email"}
                  loader={loading}
                >
                </SubmitButton>
              ) : (
                <SubmitButton
                  type="button"
                  className="main_button"
                  onClick={() => sendUpdateEmail('custom')}
                  disabled={loading}
                  btnText={loading ? "Sending..." : "Send Custom Email"}
                  loader={loading}
                >
                </SubmitButton>
              )} */}

              <button
                  type="button"
                  className="main_button  Cancle_button"
                  onClick={() => sendUpdateEmail('none')}
                  disabled={loading}
                >
                {loading ? 'Processing...' : 'Do Nothing'}
              </button>

              <button
                type="button"
                className="main_button"
                onClick={() => setCustomMode(!customMode)}
                disabled={loading}
              >
                {customMode ? 'Cancel Custom Email' : 'Compose Custom Email'}
              </button>
            </div>

            {/* <button
              type="button"
              className="main_button  Cancle_button"
              onClick={() => sendUpdateEmail('none')}
              disabled={loading}
            >
              {loading ? 'Processing...' : 'Do Nothing'}
            </button> */}

            {!customMode ? (
                <SubmitButton
                  type="button"
                  className="main_button"
                  onClick={() => sendUpdateEmail('standard')}
                  disabled={loading}
                  btnText={loading ? "Sending..." : "Send Standard Email"}
                  loader={loading}
                >
                </SubmitButton>
              ) : (
                <SubmitButton
                  type="button"
                  className="main_button"
                  onClick={() => sendUpdateEmail('custom')}
                  disabled={loading}
                  btnText={loading ? "Sending..." : "Send Custom Email"}
                  loader={loading}
                >
                </SubmitButton>
              )}
          </div>
        </div>
      </div>
    </div>
    <div className={`${show ? 'modal-backdrop fade show' : ''}`}></div>
    </>
  );
};

export default UpdateEmailConfirmationModal;
